module.exports = __webpack_public_path__ + "img/bei.1c513a57.png";